const notifications = {
  notificationsList: '/api/v1/notification/get-notifications-list',
  notificationCount: '/api/v1/notification/get-unread-notifications-count',
  notificationMarkRead: '/api/v1/notification/mark-notification-as-read',
}

export const notificationsAPIRoutes = {
  ...notifications,
}
